/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContactCreationRequestDto } from '../models';
// @ts-ignore
import type { ContactCreationResponseDto } from '../models';
// @ts-ignore
import type { ContactDto } from '../models';
// @ts-ignore
import type { ContactInfoCreationRequestDto } from '../models';
// @ts-ignore
import type { ContactInfoCreationResponseDto } from '../models';
// @ts-ignore
import type { ContactInfoDto } from '../models';
// @ts-ignore
import type { ContactInfoUpdateRequestDto } from '../models';
// @ts-ignore
import type { ContactSearchRequestDto } from '../models';
// @ts-ignore
import type { ContactSearchResponseDto } from '../models';
// @ts-ignore
import type { ContactShortDto } from '../models';
// @ts-ignore
import type { ContactUpdateRequestDto } from '../models';
/**
 * RestContactsApi - axios parameter creator
 */
export const RestContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {ContactInfoCreationRequestDto} contactInfoCreationRequestDto Create contact info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addContactInfo: async (userId: string, contactId: number, contactInfoCreationRequestDto: ContactInfoCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addContactInfo', 'userId', userId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('addContactInfo', 'contactId', contactId)
            // verify required parameter 'contactInfoCreationRequestDto' is not null or undefined
            assertParamExists('addContactInfo', 'contactInfoCreationRequestDto', contactInfoCreationRequestDto)
            const localVarPath = `/api/users/{userId}/contacts/{contactId}/infos`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactInfoCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new contact
         * @param {string} userId 
         * @param {ContactCreationRequestDto} contactCreationRequestDto Create contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (userId: string, contactCreationRequestDto: ContactCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createContact', 'userId', userId)
            // verify required parameter 'contactCreationRequestDto' is not null or undefined
            assertParamExists('createContact', 'contactCreationRequestDto', contactCreationRequestDto)
            const localVarPath = `/api/users/{userId}/contacts`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactInfo: async (userId: string, contactId: number, contactInfoId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteContactInfo', 'userId', userId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContactInfo', 'contactId', contactId)
            // verify required parameter 'contactInfoId' is not null or undefined
            assertParamExists('deleteContactInfo', 'contactInfoId', contactInfoId)
            const localVarPath = `/api/users/{userId}/contacts/{contactId}/infos/{contactInfoId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)))
                .replace('{contactInfoId}', encodeURIComponent(String(contactInfoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contact by id
         * @param {string} userId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (userId: string, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getContact', 'userId', userId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContact', 'contactId', contactId)
            const localVarPath = `/api/users/{userId}/contacts/{contactId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contact info
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfo: async (userId: string, contactId: number, contactInfoId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getContactInfo', 'userId', userId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContactInfo', 'contactId', contactId)
            // verify required parameter 'contactInfoId' is not null or undefined
            assertParamExists('getContactInfo', 'contactInfoId', contactInfoId)
            const localVarPath = `/api/users/{userId}/contacts/{contactId}/infos/{contactInfoId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)))
                .replace('{contactInfoId}', encodeURIComponent(String(contactInfoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of short people with scoring
         * @param {string} query query for contacts search
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortContacts: async (query: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('getShortContacts', 'query', query)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getShortContacts', 'userId', userId)
            const localVarPath = `/api/users/{userId}/contacts/short-search`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of user contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {ContactSearchRequestDto} contactSearchRequestDto Contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserContacts: async (page: number, pageSize: number, userId: string, contactSearchRequestDto: ContactSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchUserContacts', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchUserContacts', 'pageSize', pageSize)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('searchUserContacts', 'userId', userId)
            // verify required parameter 'contactSearchRequestDto' is not null or undefined
            assertParamExists('searchUserContacts', 'contactSearchRequestDto', contactSearchRequestDto)
            const localVarPath = `/api/users/{userId}/contacts-search`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update contact by id
         * @param {string} userId 
         * @param {number} contactId 
         * @param {ContactUpdateRequestDto} contactUpdateRequestDto Update contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (userId: string, contactId: number, contactUpdateRequestDto: ContactUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateContact', 'userId', userId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContact', 'contactId', contactId)
            // verify required parameter 'contactUpdateRequestDto' is not null or undefined
            assertParamExists('updateContact', 'contactUpdateRequestDto', contactUpdateRequestDto)
            const localVarPath = `/api/users/{userId}/contacts/{contactId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {ContactInfoUpdateRequestDto} contactInfoUpdateRequestDto Update contact info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfo: async (userId: string, contactId: number, contactInfoId: number, contactInfoUpdateRequestDto: ContactInfoUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateContactInfo', 'userId', userId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContactInfo', 'contactId', contactId)
            // verify required parameter 'contactInfoId' is not null or undefined
            assertParamExists('updateContactInfo', 'contactInfoId', contactInfoId)
            // verify required parameter 'contactInfoUpdateRequestDto' is not null or undefined
            assertParamExists('updateContactInfo', 'contactInfoUpdateRequestDto', contactInfoUpdateRequestDto)
            const localVarPath = `/api/users/{userId}/contacts/{contactId}/infos/{contactInfoId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)))
                .replace('{contactInfoId}', encodeURIComponent(String(contactInfoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactInfoUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestContactsApi - functional programming interface
 */
export const RestContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {ContactInfoCreationRequestDto} contactInfoCreationRequestDto Create contact info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addContactInfo(userId: string, contactId: number, contactInfoCreationRequestDto: ContactInfoCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addContactInfo(userId, contactId, contactInfoCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.addContactInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create new contact
         * @param {string} userId 
         * @param {ContactCreationRequestDto} contactCreationRequestDto Create contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(userId: string, contactCreationRequestDto: ContactCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(userId, contactCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContactInfo(userId, contactId, contactInfoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.deleteContactInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get contact by id
         * @param {string} userId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(userId: string, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(userId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.getContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get contact info
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactInfo(userId, contactId, contactInfoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.getContactInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of short people with scoring
         * @param {string} query query for contacts search
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShortContacts(query: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContactShortDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShortContacts(query, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.getShortContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of user contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {ContactSearchRequestDto} contactSearchRequestDto Contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUserContacts(page: number, pageSize: number, userId: string, contactSearchRequestDto: ContactSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUserContacts(page, pageSize, userId, contactSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.searchUserContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update contact by id
         * @param {string} userId 
         * @param {number} contactId 
         * @param {ContactUpdateRequestDto} contactUpdateRequestDto Update contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(userId: string, contactId: number, contactUpdateRequestDto: ContactUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(userId, contactId, contactUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {ContactInfoUpdateRequestDto} contactInfoUpdateRequestDto Update contact info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactInfo(userId: string, contactId: number, contactInfoId: number, contactInfoUpdateRequestDto: ContactInfoUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactInfo(userId, contactId, contactInfoId, contactInfoUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestContactsApi.updateContactInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestContactsApi - factory interface
 */
export const RestContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestContactsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {ContactInfoCreationRequestDto} contactInfoCreationRequestDto Create contact info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addContactInfo(userId: string, contactId: number, contactInfoCreationRequestDto: ContactInfoCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactInfoCreationResponseDto> {
            return localVarFp.addContactInfo(userId, contactId, contactInfoCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new contact
         * @param {string} userId 
         * @param {ContactCreationRequestDto} contactCreationRequestDto Create contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(userId: string, contactCreationRequestDto: ContactCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactCreationResponseDto> {
            return localVarFp.createContact(userId, contactCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContactInfo(userId, contactId, contactInfoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get contact by id
         * @param {string} userId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(userId: string, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<ContactDto> {
            return localVarFp.getContact(userId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get contact info
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig): AxiosPromise<ContactInfoDto> {
            return localVarFp.getContactInfo(userId, contactId, contactInfoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of short people with scoring
         * @param {string} query query for contacts search
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortContacts(query: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContactShortDto>> {
            return localVarFp.getShortContacts(query, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of user contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {ContactSearchRequestDto} contactSearchRequestDto Contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserContacts(page: number, pageSize: number, userId: string, contactSearchRequestDto: ContactSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto> {
            return localVarFp.searchUserContacts(page, pageSize, userId, contactSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update contact by id
         * @param {string} userId 
         * @param {number} contactId 
         * @param {ContactUpdateRequestDto} contactUpdateRequestDto Update contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(userId: string, contactId: number, contactUpdateRequestDto: ContactUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContact(userId, contactId, contactUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update contact infos
         * @param {string} userId 
         * @param {number} contactId 
         * @param {number} contactInfoId 
         * @param {ContactInfoUpdateRequestDto} contactInfoUpdateRequestDto Update contact info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactInfo(userId: string, contactId: number, contactInfoId: number, contactInfoUpdateRequestDto: ContactInfoUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContactInfo(userId, contactId, contactInfoId, contactInfoUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestContactsApi - interface
 */
export interface RestContactsApiInterface {
    /**
     * 
     * @summary Add contact infos
     * @param {string} userId 
     * @param {number} contactId 
     * @param {ContactInfoCreationRequestDto} contactInfoCreationRequestDto Create contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addContactInfo(userId: string, contactId: number, contactInfoCreationRequestDto: ContactInfoCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactInfoCreationResponseDto>;

    /**
     * 
     * @summary Create new contact
     * @param {string} userId 
     * @param {ContactCreationRequestDto} contactCreationRequestDto Create contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createContact(userId: string, contactCreationRequestDto: ContactCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactCreationResponseDto>;

    /**
     * 
     * @summary Delete contact infos
     * @param {string} userId 
     * @param {number} contactId 
     * @param {number} contactInfoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get contact by id
     * @param {string} userId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContact(userId: string, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<ContactDto>;

    /**
     * 
     * @summary Get contact info
     * @param {string} userId 
     * @param {number} contactId 
     * @param {number} contactInfoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig): AxiosPromise<ContactInfoDto>;

    /**
     * 
     * @summary Get list of short people with scoring
     * @param {string} query query for contacts search
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShortContacts(query: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContactShortDto>>;

    /**
     * 
     * @summary Get list of user contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} userId 
     * @param {ContactSearchRequestDto} contactSearchRequestDto Contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUserContacts(page: number, pageSize: number, userId: string, contactSearchRequestDto: ContactSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto>;

    /**
     * 
     * @summary Update contact by id
     * @param {string} userId 
     * @param {number} contactId 
     * @param {ContactUpdateRequestDto} contactUpdateRequestDto Update contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContact(userId: string, contactId: number, contactUpdateRequestDto: ContactUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update contact infos
     * @param {string} userId 
     * @param {number} contactId 
     * @param {number} contactInfoId 
     * @param {ContactInfoUpdateRequestDto} contactInfoUpdateRequestDto Update contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContactInfo(userId: string, contactId: number, contactInfoId: number, contactInfoUpdateRequestDto: ContactInfoUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestContactsApi - object-oriented interface
 */
export class RestContactsApi extends BaseAPI implements RestContactsApiInterface {
    /**
     * 
     * @summary Add contact infos
     * @param {string} userId 
     * @param {number} contactId 
     * @param {ContactInfoCreationRequestDto} contactInfoCreationRequestDto Create contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addContactInfo(userId: string, contactId: number, contactInfoCreationRequestDto: ContactInfoCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).addContactInfo(userId, contactId, contactInfoCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new contact
     * @param {string} userId 
     * @param {ContactCreationRequestDto} contactCreationRequestDto Create contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createContact(userId: string, contactCreationRequestDto: ContactCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).createContact(userId, contactCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete contact infos
     * @param {string} userId 
     * @param {number} contactId 
     * @param {number} contactInfoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).deleteContactInfo(userId, contactId, contactInfoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get contact by id
     * @param {string} userId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContact(userId: string, contactId: number, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).getContact(userId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get contact info
     * @param {string} userId 
     * @param {number} contactId 
     * @param {number} contactInfoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContactInfo(userId: string, contactId: number, contactInfoId: number, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).getContactInfo(userId, contactId, contactInfoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of short people with scoring
     * @param {string} query query for contacts search
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getShortContacts(query: string, userId: string, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).getShortContacts(query, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of user contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} userId 
     * @param {ContactSearchRequestDto} contactSearchRequestDto Contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUserContacts(page: number, pageSize: number, userId: string, contactSearchRequestDto: ContactSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).searchUserContacts(page, pageSize, userId, contactSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update contact by id
     * @param {string} userId 
     * @param {number} contactId 
     * @param {ContactUpdateRequestDto} contactUpdateRequestDto Update contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateContact(userId: string, contactId: number, contactUpdateRequestDto: ContactUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).updateContact(userId, contactId, contactUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update contact infos
     * @param {string} userId 
     * @param {number} contactId 
     * @param {number} contactInfoId 
     * @param {ContactInfoUpdateRequestDto} contactInfoUpdateRequestDto Update contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateContactInfo(userId: string, contactId: number, contactInfoId: number, contactInfoUpdateRequestDto: ContactInfoUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestContactsApiFp(this.configuration).updateContactInfo(userId, contactId, contactInfoId, contactInfoUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

